// ViewershipSparklines.jsx
import React from 'react';

import { CenteringDiv, Grid, Cell } from '../../base/styled';
import { SparklineWidget } from '../../widgets';

const ViewershipSparklines = (props) => {

  const {
    uniqueViewersPlayerstats,
    uniqueViewersSlinganalytics,
    uniqueDevicesPlayerstats,
    uniqueDevicesSlinganalytics,
  } = props;

  return (
    <div className="dashboard">
      <CenteringDiv>
        <Grid columns={2} rows="50px 1fr 1fr" columnGap="50px">
          <Cell width={2}>
            <div style={{ fontSize: '1.5em' }}>UNIQUE VIEWERS AND DEVICES (PLAYERSTATS, SLINGANALYTICS)</div>
          </Cell>
          <Cell>
            <SparklineWidget input={uniqueViewersPlayerstats} />
          </Cell>
          <Cell>
            <SparklineWidget input={uniqueViewersSlinganalytics} />
          </Cell>
          <Cell>
            <SparklineWidget input={uniqueDevicesPlayerstats} />
          </Cell>
          <Cell>
            <SparklineWidget input={uniqueDevicesSlinganalytics} />
          </Cell>
        </Grid>
      </CenteringDiv>
    </div>
  );

};

// Defining propTypes helps flag errors but isn't strictly necessary
ViewershipSparklines.propTypes = {
  uniqueViewersPlayerstats: SparklineWidget.propTypes.isRequired,
  uniqueViewersSlinganalytics: SparklineWidget.propTypes.isRequired,
  uniqueDevicesPlayerstats: SparklineWidget.propTypes.isRequired,
  uniqueDevicesSlinganalytics: SparklineWidget.propTypes.isRequired,
};

export default ViewershipSparklines;
